import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthRedirect = ({
                          isCabinet = false,
                          cabinetPath = '/cabinet/wallet',
                          emailVerifyPath = '/email-verify',
                          signInPath = '/sign-in',
                      }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const tokenStatus = useSelector(store => store.main.tokenStatus);
    const authStatus = useSelector(store => store.main.authorizationStatus);
    const subscribeStatus = useSelector(store => store.cabinet.subscribeStatus);

    useEffect(() => {
        const isSubscriptionActive = subscribeStatus === 'active';
        const isWalletPage = location.pathname === cabinetPath;

        /**
         * Режим для страниц кабинета.
         */
        if (isCabinet) {
            if (!tokenStatus || !authStatus) {
                if (location.pathname !== signInPath) {
                    navigate(signInPath, { replace: true });
                }

                return;
            }

            /**
             * Если пользователь авторизован, но подписка не активна —
             * со всех страниц кабинета отправляем на /cabinet/wallet.
             * Сам /cabinet/wallet остаётся доступным.
             */
            if (!isSubscriptionActive && !isWalletPage) {
                navigate(cabinetPath, { replace: true });
                return;
            }

            return;
        }

        /**
         * Режим для публичных auth-страниц:
         * sign-in, sign-up, reset-password и т.д.
         */
        if (tokenStatus && authStatus) {
            if (location.pathname !== cabinetPath) {
                navigate(cabinetPath, { replace: true });
            }

            return;
        }

        if (tokenStatus && !authStatus) {
            if (location.pathname !== emailVerifyPath) {
                navigate(emailVerifyPath, { replace: true });
            }
        }
    }, [
        isCabinet,
        tokenStatus,
        authStatus,
        subscribeStatus,
        navigate,
        location.pathname,
        cabinetPath,
        emailVerifyPath,
        signInPath,
    ]);

    return null;
};

export default AuthRedirect;